import script from "./DescribeUser.vue?vue&type=script&setup=true&lang=js"
export * from "./DescribeUser.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__